import Box from '@material-ui/core/Box';
import useLayout from '../../styles/layout'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { reserveRoutes } from '../../router/routeConfig'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { SelectInput, TextInput, DateInput, CheckBoxGroupInput } from '../../components/common/components'
import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Helmet } from "react-helmet";
import { useHistory, useParams } from "react-router-dom";
import ProgressBar from '../../components/ProgressBar'
import CircularProgress from '@material-ui/core/CircularProgress';
import { getSchdTimeOptions, getConsultOptions } from '../../actions'
import { setFormValue } from '../../actions'
import Swal from 'sweetalert2'
import EventCalendar from '../../components/common/Calendar';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function SchdTime() {

    const layoutClasses = useLayout()

    const location = useLocation();

    const idx = _.findIndex(reserveRoutes, (o) => o.path === location.pathname)

    const option = (useSelector(state => state.get("option"))).toJS()

    const form = (useSelector(state => state.get("form"))).toJS()

    const [timeSelected, setTimeSelected] = useState(null)

    const dispatch = useDispatch()

    let history = useHistory();

    let query = useQuery();

    let schd_type = query.get("schd_type")
    
    let page_src = query.get("src")
    let tk = query.get("tk")

    useEffect(() => {
        if (!schd_type) {
            window.location.href = './first_step'
        }
    }, [schd_type])

    useEffect(() => {
        if (tk && schd_type === "A5") {
            dispatch(setFormValue({
                field: "TICKET_NO",
                value: tk
            }))
        }
    }, [])

    useEffect(() => {
        dispatch(getConsultOptions(schd_type))    
        setTimeSelected(null)    
    }, [schd_type, dispatch])

    useEffect(()=>{
        dispatch(getSchdTimeOptions(schd_type, form.consult))
        setTimeSelected(null) 
    }, [schd_type, dispatch, form.consult])

    const handlechange = useCallback((field, value) => {

        dispatch(setFormValue({
            field,
            value
        }))
        // if(field === 'conformId'){
        //     dispatch(setFormValue({
        //         'field': 'schdTimeId',
        //         'value':''
        //     }))
        // }        
    }, [dispatch])

    useEffect(()=>{

        if(timeSelected){
            handlechange("schdTimeId", timeSelected.SCHD_ID)
        }else{
            handlechange("schdTimeId", "")
        }

    }, [timeSelected, handlechange])
    
    useEffect(() => {

        if (!form.conformId && option.conform.length > 0) {
            dispatch(setFormValue(
                { field: "conformId", value: option.conform[0].value }
            ))
        }

    }, [option.conform, dispatch, form.conformId])

    const handleNextClick = () => {

        if (!form.schdTimeId) {
            Swal.fire(`請選擇預約時間`, "", "error")
            return
        }

        history.push(`/third_step?schd_type=${schd_type}`)
    }

    return <Box className={layoutClasses.page}>
        <Helmet>
            <title>{reserveRoutes[idx].name}</title>
        </Helmet>
        <ProgressBar />
        <Paper
            elevation={3}
            square
            className={layoutClasses.paper}
        >
            <Typography variant="subtitle1" gutterBottom align="center">
                {reserveRoutes[idx].name}
            </Typography>
            <CheckBoxGroupInput
                label="選擇項目"
                options={JSON.stringify(option.consult)}
                field="consult"
                value={form.consult}
                setValue={handlechange}
            />
            {form.consult.includes("AH2") && <Typography style={{marginLeft: "10px",color:"red"}}>若您未完成成人預防保健(報名)及抽血檢查，將無法提供成人預防保健(回診)服務。</Typography>}
            <div style={{ padding: "10px"}}>
                <Typography variant="subtitle1" gutterBottom>
                    選擇時段
                </Typography>
                
                {option.schdTime.length === 0 && <Typography variant="subtitle1" gutterBottom style={{color:"red"}}>
                    選擇項目無可預約時段
                </Typography>}
                

                {/* <SelectInput
                label={`預約時間`}
                field="schdTimeId"
                value={form.schdTimeId}
                setValue={handlechange}
                options={JSON.stringify(option.schdTime)}
                
            />           */}
                <EventCalendar
                    events={option.schdTime}
                    onSelect={(e)=>{
                        if(e.disabled){
                            return
                        }
                        setTimeSelected(e)
                    }}
                    selected={timeSelected}
                />
            </div>




            {option.loading ?
                <div style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0,0,0,0.3)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <CircularProgress size={200} />
                </div> : null}
        </Paper>
        <div>
            {page_src && page_src === "first_step" ?
                <Button
                    variant="contained"
                    // color="secondary"
                    style={{ margin: "30px" }}
                    onClick={() => { window.location.href = "./first_step" }}
                >
                    上一步
                </Button> : null}
            <Button
                variant="contained"
                color="primary"
                style={{ margin: "30px" }}
                onClick={() => { handleNextClick() }}
            >
                下一步
            </Button>
        </div>

    </Box>
}


